import { render, staticRenderFns } from "./TableManager.vue?vue&type=template&id=54a93cde"
import script from "./TableManager.vue?vue&type=script&lang=js"
export * from "./TableManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports